module.exports = __webpack_public_path__ + "static/media/Water_hyacinth_GettyImages-170500069.b09e14fb.jpg";